export default __webpack_public_path__ + "WFM_Logo.67c58f11.png";